import type {
  CaseStatus,
  RemovalStatus,
  SiteMethod,
} from "@/types/admin";

export const removalStatusConfig: Record<
  RemovalStatus,
  { label: string; className: string }
> = {
  todo: {
    label: "Att göra",
    className:
      "bg-slate-100 dark:bg-slate-800/50 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-700",
  },
  submitted: {
    label: "Skickad",
    className:
      "bg-cyan-100 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-300 border-cyan-300 dark:border-cyan-800",
  },
  confirmed: {
    label: "Bekräftad",
    className:
      "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border-green-300 dark:border-green-800",
  },
  failed: {
    label: "Misslyckades",
    className:
      "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300 border-red-300 dark:border-red-800",
  },
  not_found: {
    label: "Hittades ej",
    className:
      "bg-slate-100 dark:bg-slate-800/50 text-slate-600 dark:text-slate-400 border-slate-300 dark:border-slate-700",
  },
  needs_customer_action: {
    label: "Kräver kundåtgärd",
    className:
      "bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-300 border-amber-300 dark:border-amber-800",
  },
};

export const removalStatusOrder: RemovalStatus[] = [
  "todo",
  "submitted",
  "confirmed",
  "failed",
  "not_found",
  "needs_customer_action",
];

export const siteMethodLabel: Record<SiteMethod, string> = {
  web_form: "Webbformulär",
  email: "E-post",
  postal: "Post",
  bankid_required: "BankID krävs",
};

export const caseStatusConfig: Record<
  CaseStatus,
  { label: string; className: string }
> = {
  draft: {
    label: "Utkast",
    className:
      "bg-slate-100 dark:bg-slate-800/50 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-700",
  },
  active: {
    label: "Aktiv",
    className:
      "bg-cyan-100 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-300 border-cyan-300 dark:border-cyan-800",
  },
  monitoring: {
    label: "Övervakning",
    className:
      "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-300 border-indigo-300 dark:border-indigo-800",
  },
  completed: {
    label: "Slutförd",
    className:
      "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border-green-300 dark:border-green-800",
  },
  cancelled: {
    label: "Avbruten",
    className:
      "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300 border-red-300 dark:border-red-800",
  },
};
